module.exports = __webpack_public_path__ + "images/assets/bbf4bc96579379c2cb93ae739938ec64.svg";